import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 9524D285-4F39-4FEA-9EC1-9F4B6ACB6615
 * name bottle-tonic-plus
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-tonic-plus.svg
 * tags
 * - Gaming / RPG 
 */
export const BottleTonicPlusIcon = createSvgIcon(<><path d="M13 4H11L10 2H14L13 4M14 8V6H15V5H9V6H10V8C7.24 8 5 10.24 5 13V22H19V13C19 10.24 16.76 8 14 8M16 17H13V20H11V17H8V15H11V12H13V15H16V17Z" /></>, 'BottleTonicPlusIcon');
export default BottleTonicPlusIcon